import type { CalendarSubscribeOutcome } from "@/lib/google-calendar-subscribe";

/** The Google Calendar row's words, shared by the row and its tests. */
export const GOOGLE_CALENDAR_COPY = {
  label: "Google Calendar",
  job: "Put this course's sessions in the person's own Google Calendar, kept current by IMAM.",
  add: "Add to Google Calendar",
  open: "Open in Google Calendar",
  available: "Your sessions, kept current in your Google Calendar.",
  added: "In your Google Calendar. Changes arrive on their own.",
  noAccount: "Needs your school Google account. Ask your registrar.",
  detail: "Moves and cancellations update by themselves.",
  failed: "Couldn't read your Google Calendar link.",
  stale: "Couldn't refresh. A later change isn't shown.",
  blocked: "Allow a new tab to open Google Calendar, then try again.",
  notAdded: "Google Calendar didn't answer. Try again.",
  wrongAccount: "Google added nothing to that account. Choose your school account and try again.",
  declined: "Google Calendar wasn't allowed, so nothing was added.",
  popupBlocked: "Allow Google's window to open, then try again.",
  addedHere: "In your Google Calendar.",
} as const;

/** The all-courses row's words. */
export const MY_CALENDARS_COPY = {
  label: "Google Calendar",
  job: "Put every course's sessions in the person's own Google Calendar, kept current by IMAM.",
  addAll: "Add all to Google Calendar",
  addNew: (n: number) => `Add ${n} new`,
  open: "Open Google Calendar",
  available: (n: number) => `Your ${n === 1 ? "course's" : `${n} courses'`} sessions, kept current in your Google Calendar.`,
  someNew: (n: number) => `${n === 1 ? "1 new course isn't" : `${n} new courses aren't`} in your Google Calendar yet.`,
  allAdded: (n: number) => `${n === 1 ? "Your course is" : `All ${n} courses are`} in your Google Calendar.`,
  detail: "Moves and cancellations update by themselves.",
  failed: "Couldn't read your Google Calendar.",
  stale: "Couldn't refresh. A later change isn't shown.",
  done: (n: number) => `${n === 1 ? "1 course" : `${n} courses`} in your Google Calendar.`,
  stillPreparing: (n: number) => `${n === 1 ? "1 is" : `${n} are`} still being prepared. Press again in a minute.`,
  notAll: (n: number) => `${n === 1 ? "1 wasn't" : `${n} weren't`} added. Try again.`,
} as const;

/** What a subscribe press that added nothing says beside the row; null when it says nothing. */
export function subscribeProblem(outcome: CalendarSubscribeOutcome, notAdded: string): string | null {
  const copy = GOOGLE_CALENDAR_COPY;
  if (outcome.kind === "cancelled" || outcome.kind === "added") return null;
  if (outcome.kind === "wrong_account") return copy.wrongAccount;
  if (outcome.reason === "declined") return copy.declined;
  if (outcome.reason === "popup_blocked") return copy.popupBlocked;
  if (outcome.reason === "no_token") return copy.wrongAccount;
  return notAdded;
}
